<div class="modal-fade modal-confirm">
  <div class="modal-content">
    <div class="modal-header justify-content-center">
      <div class="icon-box">
        <em class="bi bi-question-circle icon"></em>
        <em class="fas fa-question icon"></em>
      </div>
    </div>
    <div class="modal-body text-center">
      <h5 class="mt-4">{{ message }}</h5>
      <div class="row mt-5">
        <div class="col-md-6">
          <button
            type="button"
            class="btn btn-gray mt-2 mb-2 w-100"
            (click)="onActionTake(false)"
            *ngIf="negative"
          >
            {{ negative }}
          </button>
        </div>
        <div class="col-md-6">
          <button
            type="button"
            class="btn btn-red mt-2 mb-2 w-100"
            (click)="onActionTake(true)"
          >
            {{ positive }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
